import { render, staticRenderFns } from "./right-box.vue?vue&type=template&id=2a027c45&"
import script from "./right-box.vue?vue&type=script&lang=js&"
export * from "./right-box.vue?vue&type=script&lang=js&"
import style0 from "./right-box.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports